import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './../../api.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.css']
})
export class RequestsComponent {
  id = localStorage.getItem('user_id');
  isLoading = false;
  all: any[] = [];
  tab = 'all';
  searchText = '';
  sortBy = 'newest';
  acceptingId: any = null;

  tabs = [
    { key: 'all', label: 'All Requests' },
    { key: 'received', label: 'Received' },
    { key: 'sent', label: 'Sent' },
    { key: 'accepted', label: 'Accepted' }
  ];

  constructor(private apiService: ApiService, private router: Router) {
    this.load();
  }

  load() {
    this.isLoading = true;
    forkJoin({
      req: this.apiService.myRequests(this.id).pipe(catchError(() => of(null))),
      con: this.apiService.getContact(parseInt(this.id as string, 10)).pipe(catchError(() => of(null)))
    }).subscribe(({ req, con }: any) => {
      const rows: any[] = [];
      const seen = new Map<string, any>();

      const add = (row: any) => {
        const k = row.friendId ? 'u' + row.friendId : row.key;
        const ex = seen.get(k);
        if (ex) {
          if (row.status === 'Accepted') ex.status = 'Accepted';
          if (ex.dir === 'connected' && row.dir !== 'connected') ex.dir = row.dir;
          return;
        }
        seen.set(k, row);
        rows.push(row);
      };

      (req?.requestsRecievedByMe || []).forEach((x: any) => add(this.mapReq(x, 'received')));
      (req?.requestsSentByMe || []).forEach((x: any) => add(this.mapReq(x, 'sent')));
      (con?.contacts || []).forEach((c: any) => add(this.mapContact(c)));

      this.all = rows;
      this.isLoading = false;
    });
  }

  private photoOf(u: any): string | null {
    const p = u?.profile_image;
    if (!p || typeof p !== 'string') return null;
    return p.startsWith('data:image') || p.startsWith('http') ? p : 'data:image/jpeg;base64,' + p;
  }

  private build(x: any, u: any, dir: string, key: string) {
    return {
      key, id: x.id, friendId: u?.id, dir, status: x.status,
      name: ((u?.firstname || '') + ' ' + (u?.lastname || '')).trim(),
      sub: [u?.job_title, u?.company].filter(Boolean).join(' | '),
      photo: this.photoOf(u),
      created: (x.updated_at || x.created_at) ? new Date(x.updated_at || x.created_at).getTime() : 0
    };
  }

  private mapReq(x: any, dir: string) {
    return this.build(x, x.frnd, dir, 'r' + x.id);
  }

  private mapContact(c: any) {
    let dir = 'connected';   // direction pata na ho to
    if (c.user_id !== undefined && c.friend_id !== undefined) {
      dir = String(c.user_id) === String(this.id) ? 'sent' : 'received';
    }
    return this.build(c, c.user, dir, 'c' + c.id);
  }

  matchTab(r: any, key: string) {
    if (key === 'all') return true;
    if (key === 'accepted') return r.status === 'Accepted';
    return r.dir === key;
  }
  count(key: string) { return this.all.filter(r => this.matchTab(r, key)).length; }
  pending() { return this.all.filter(r => r.status === 'Pending').length; }

  get filtered(): any[] {
    const q = this.searchText.trim().toLowerCase();
    const list = this.all.filter(r =>
      this.matchTab(r, this.tab) && (!q || (r.name + ' ' + r.sub).toLowerCase().includes(q)));
    return list.sort((a, b) =>
      this.sortBy === 'name' ? a.name.localeCompare(b.name) : (b.created - a.created) || (b.id - a.id));
  }

  ago(ts: number): string {
    if (!ts) return '';
    const s = Math.floor((Date.now() - ts) / 1000);
    if (s < 60) return 'just now';
    if (s < 3600) return Math.floor(s / 60) + ' mins ago';
    if (s < 86400) return Math.floor(s / 3600) + ' hours ago';
    return Math.floor(s / 86400) + ' days ago';
  }

  accept(r: any) {
    this.acceptingId = r.id;
    this.apiService.acceptRequest(r.id).subscribe(
      (res: any) => {
        this.acceptingId = null;
        if (res.status == 'Success') { r.status = 'Accepted'; r.created = Date.now(); }
        else alert('Could not accept the request. Please try again.');
      },
      () => { this.acceptingId = null; alert('Could not accept the request. Please try again.'); }
    );
  }

  message() { this.router.navigate(['/messages']); }
}